export default __webpack_public_path__ + "static/media/15.fa26f54b.jpeg";